import React, { useEffect, useState } from "react";

// images import
import filter from "../../assets/images/filter.svg";
import date from "../../assets/images/date.svg";
import comonicon from "../../assets/images/comonicon.svg";
import ac1 from "../../assets/images/ac1.svg";
import ac2 from "../../assets/images/ac2.svg";
import ac3 from "../../assets/images/ac3.svg";
import ac4 from "../../assets/images/ac4.svg";
import ac5 from "../../assets/images/ac5.svg";
import ac6 from "../../assets/images/ac6.svg";
import clm from "../../assets/images/clm.svg";
import ged from "../../assets/images/ged.svg";
import { Link, useNavigate } from "react-router-dom";

import SelectedAccountComponent from "../Dashboardcomponent/SelectedAccount";
import SelectedAssetsComponent from "../Dashboardcomponent/SelectedAssetsComponent";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import {
  CalculationBalance,
  Get_RiskLevel_id,
  Risk_Level1_Data,
  Risk_Level2_Data,
  Risk_Level3_Data,
  SelectedAccount,
  SelectedAsset,
  UserDetails,
  storeRiskLevel1,
  storeRiskLevel2,
  storeRiskLevel3,
} from "../../redux/userSlice";

// import AccountAssets from "./AccountAssets";
// import LoaderModal from "../ModalLoader/LoaderModal";

import RiskLevel1_Table from "../Account2Component.js/RiskLevel1_Table";
import RiskLevel2_Table from "../Account2Component.js/RiskLevel2_Table";
import RiskLevel3_Table from "../Account2Component.js/RiskLevel3_Table";
import { GoQuestion } from "react-icons/go";

const AssetCalcualtion = () => {
  const [risk_show, setRisk_Show] = useState("all");

  const navigate = useNavigate();

  const userDetails = useSelector(UserDetails);
  const token = userDetails?.token;
  const APi_Url = process.env.REACT_APP_ENIGMA_API;
  const dispatch = useDispatch();

  const selectedAccountDetails = useSelector(SelectedAccount);
  const CalculationResponse = useSelector(CalculationBalance);
  const Risk_ID = useSelector(Get_RiskLevel_id);

  // aggressive,neutral,conservative data get using redux store
  const risk_Level1 = useSelector(Risk_Level1_Data);
  const risk_Level2 = useSelector(Risk_Level2_Data);
  const risk_Level3 = useSelector(Risk_Level3_Data);

  // const [loaderStatus,setLoaderStatus]  =useState(false);

  const selectedAssetDetails = useSelector(SelectedAsset);

  const expID = CalculationResponse?.experienceId;
  const aggressiveDRPTBalance = CalculationResponse?.aggressiveDRPT;

  //  CalculationResponse?.nurtalCoefficient > 0
  //  CalculationResponse?.conservativeCoefficient > 0
  //  CalculationResponse?.aggressiveCoefficient > 0

  useEffect(() => {
    if (expID == 1 && CalculationResponse?.conservativeCoefficient > 0) {
      setRisk_Show("Conservative");
    } else if (expID == 1 && CalculationResponse?.nurtalCoefficient > 0) {
      setRisk_Show("Neutral");
    } else if (expID == 1 && CalculationResponse?.aggressiveCoefficient > 0) {
      setRisk_Show("Aggressive");
    } else if (expID == 2 && CalculationResponse?.aggressiveCoefficient > 0) {
      setRisk_Show("Aggressive");
    } else if (expID == 2 && CalculationResponse?.nurtalCoefficient > 0) {
      setRisk_Show("Neutral");
    } else if (expID == 2 && CalculationResponse?.conservativeCoefficient > 0) {
      setRisk_Show("Conservative");
    }
  }, [expID, aggressiveDRPTBalance]);
  useEffect(() => {
    if (Risk_ID == 1) {
      setRisk_Show("Aggressive");
    } else if (Risk_ID == 2) {
      setRisk_Show("Neutral");
    } else if (Risk_ID == 3) {
      setRisk_Show("Conservative");
    }
  }, [Risk_ID]);
  //   console.log("Risk_ID",Risk_ID);
  // console.log("risk_show",risk_show);

  const [account_status, setAccount_status] = useState();

  // console.log("account_status in asset calcualtion",account_status)
  useEffect(() => {
    AccountStatus();
  }, [selectedAccountDetails?.accountId]);

  const AccountStatus = async () => {
    try {
      const response = await axios.get(
        `${APi_Url}api/account/get-source-account-by-sourceid/${userDetails.id}/${selectedAccountDetails?.accountId}`,

        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // console.log(
      //   "get-source-account-by-sourceid status",
      //   response.data.response.status
      // );
      setAccount_status(response.data.response.status);
      if (!response.data.response.status) {
        dispatch(storeRiskLevel1(null));
        dispatch(storeRiskLevel2(null));
        dispatch(storeRiskLevel3(null));
      }
      // Handle response data as needed
    } catch (error) {
      // console.error("Error ", error);
    }
  };

  const formatNumber = (number) => {
    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Math.abs(number));
  };

  // if (CalculationResponse == null) {
  //   navigate('/dashboard', { replace: true })
  // }

  // console.log("risk level",risk_Level1)
  return (
    // <!-- start dashbordsect -->
    <section className="managementsect managementsectmrtop">
      <div className="hadformsect dflcol">
        <h2>
          {selectedAccountDetails?.accountName} -{" "}
          {selectedAssetDetails
            ? selectedAssetDetails?.assetName
            : "Please choose asset"}
        </h2>
        <div className="dselectbox formobilstyl">
          {/* <div className="formslbox">
           
            <SelectedAccountComponent AccountStatus_function={AccountStatus} />
          </div>
          <div className="formslbox">
       
            <SelectedAssetsComponent AccountStatus={account_status} />
          </div> */}
          {/* <div className="datpickbox">
            <img src={filter} alt="" />
          </div>
          <div className="datpickbox">
            <img src={date} alt="" />
          </div> */}
        </div>
      </div>

      {risk_Level1 ? (
        <div className="row">
          <div className="col-lg-12">
            <div className="boxflexlist">
              <div className="whitbox width2">
                <div className="dropflex mb-0">
                  <div className="imgboxflex">
                    <div className="iconcomonbox">
                      <img src={ac1} alt="" />
                    </div>
                    <span className="icontext">
                      <h5 class="tooltip-target amount-data">Point Value</h5>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                            Point Value is the amount of $ that your account
                            will either profit or loss per every 1.00 that the
                            instrument moves.
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  {risk_Level1 != null && risk_Level1.length > 0 ? (
                    <h3>{`$${formatNumber(risk_Level1[0].pointValue)}`}</h3>
                  ) : (
                    "NA"
                  )}
                </div>
              </div>
              {/* Tick Size */}
              <div className="whitbox width2">
                <div className="dropflex mb-0">
                  <div className="imgboxflex">
                    <div className="iconcomonbox">
                      <img src={ac2} alt="" />
                    </div>
                    <span className="icontext">
                      <h5 class="tooltip-target amount-data">Tick Size</h5>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                            Tick size is the smallest possible price movement in
                            a financial market, usually set by the exchange. It
                            represents the minimum amount by which the price of
                            a security, like a stock or a futures contract, can
                            increase or decrease. For example, if a stock has a
                            tick size of $0.01, it means its price can move up
                            or down only in increments of one cent. Tick size
                            helps standardize price movements, making trading
                            more organized and consistent across the market.
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  {risk_Level1 != null && risk_Level1.length > 0 ? (
                    <h3>{`$${formatNumber(risk_Level1[0].tickSize)}`}</h3>
                  ) : (
                    "NA"
                  )}
                </div>
              </div>
              {/* Commission */}
              <div className="whitbox width2">
                <div className="dropflex mb-0">
                  <div className="imgboxflex">
                    <div className="iconcomonbox">
                      <img src={ac1} alt="" />
                    </div>
                    <span className="icontext">
                      <h5 class="tooltip-target amount-data">Commission</h5>
                      <div className="tooltipico">
                        <div class="tooltip-container">
                          <span className="tooltipsvg">
                            <GoQuestion />
                          </span>
                          <div class="tooltip">
                            Commission is a fee that a trader or investor pays
                            to a broker or financial service provider for
                            executing a buy or sell order on their behalf. It’s
                            like a small charge for the service of handling the
                            trade.
                          </div>
                        </div>
                      </div>
                    </span>
                  </div>
                  {risk_Level1 != null && risk_Level1.length > 0 ? (
                    <h3>{`$${formatNumber(risk_Level1[0].rtComms)}`}</h3>
                  ) : (
                    "NA"
                  )}
                </div>
              </div>
            </div>
          </div>

          {expID == 2 ? (
            <div className="col-lg-12">
              <div className="hadformsect dflexformobil">
                <div className="dselectbox ml_auto">
                  <div className="formslbox">
                    <div className="dropdown">
                      <button
                        className="btn dropdown-toggle form-select"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {risk_show}
                      </button>
                      <ul className="dropdown-menu">
                        <li>
                          <Link
                            className="dropdown-item"
                            onClick={() => setRisk_Show("all")}
                          >
                            All
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item"
                            onClick={() => setRisk_Show("Aggressive")}
                          >
                            Aggressive
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item"
                            onClick={() => setRisk_Show("Neutral")}
                          >
                            Neutral
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="dropdown-item"
                            onClick={() => setRisk_Show("Conservative")}
                          >
                            Conservative
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  {/* <div className="datpickbox clmgrd">
                <div className={tableView ? "clgditeam active" : "clgditeam"}>
                  <img src={clm} alt="" onClick={tableview} />
                </div>
                <div
                  className={tabView ? "clgditeam active" : "clgditeam"}
                  onClick={tabview}
                >
                  <img src={ged} alt="" />
                </div>
              </div> */}
                </div>
              </div>

              <div className="accountchatsect">
                {risk_show === "all" ? (
                  <>
                    {" "}
                    <RiskLevel1_Table
                      clCalculation={CalculationResponse}
                      RiskLevel1_Data={risk_Level1}
                    />
                    <RiskLevel2_Table
                      clCalculation={CalculationResponse}
                      RiskLevel2_Data={risk_Level2}
                      RiskLevel1_Data={risk_Level1}
                    />
                    <RiskLevel3_Table
                      clCalculation={CalculationResponse}
                      RiskLevel3_Data={risk_Level3}
                      RiskLevel2_Data={risk_Level2}
                      RiskLevel1_Data={risk_Level1}
                    />
                  </>
                ) : risk_show === "Aggressive" ? (
                  <>
                    <RiskLevel1_Table
                      clCalculation={CalculationResponse}
                      RiskLevel1_Data={risk_Level1}
                    />
                  </>
                ) : risk_show === "Neutral" ? (
                  <>
                    {" "}
                    <RiskLevel2_Table
                      clCalculation={CalculationResponse}
                      RiskLevel2_Data={risk_Level2}
                    />
                  </>
                ) : (
                  <RiskLevel3_Table
                    clCalculation={CalculationResponse}
                    RiskLevel3_Data={risk_Level3}
                  />
                )}
              </div>
            </div>
          ) : null}

          {expID == 1 ? (
            <div className="col-lg-12">
              <div className="accountchatsect">
                <RiskLevel3_Table
                  clCalculation={CalculationResponse}
                  RiskLevel3_Data={risk_Level3}
                />
              </div>
            </div>
          ) : null}
        </div>
      ) : (
        // (
        //   <div className="row">
        //     <div className="col-lg-12">
        //       <div className="boxflexlist flwrap aclwhitbox">
        //         <div className="whitbox  whitflex">
        //           <h1>No data found</h1>
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        // )
        ""
      )}
    </section>
  );
};

export default AssetCalcualtion;
